module.exports = __webpack_public_path__ + "img/tear.435998a9.png";